module.exports = __webpack_public_path__ + "static/img/2_1.e601f7e2.jpg";